import { configureStore } from '@reduxjs/toolkit';
import companydetailsReducer from './companydetails';
import userdetailsReducer from './userdetails';
export const store = configureStore({
    reducer: {
        companydetails: companydetailsReducer,
        userdetails: userdetailsReducer
    }
})